if (!customElements.get('comment-item-swiper')) {
    class CommentItemSwiper extends HTMLElement {
        constructor() {
            super();
            this._swiperContainer = null;
            this._swiperInstance = null;
            this._resizeHandler = this._onResize.bind(this);
        }

        connectedCallback() {
            requestAnimationFrame(() => {
                this._swiperContainer = this.querySelector('.swiper');
                this.initializeSwiper();
                // this.sameHeight();
                window.addEventListener('resize', this._resizeHandler);
            });
        }

        disconnectedCallback() {
            window.removeEventListener('resize', this._resizeHandler);
        }

        _onResize() {
            if (window.innerWidth > 1440) {
                if (this._swiperInstance) {
                    const newSlidesOffsetBefore = this._calculateSlidesOffsetBefore();
                    this._swiperInstance.params.slidesOffsetBefore = newSlidesOffsetBefore;
                    this._swiperInstance.update();
                }
            }
            // this.sameHeight();
        }

        _calculateSlidesOffsetBefore() {
            // 获取页面中第一个匹配的 .page-width 元素
            const element = document.querySelector('.page-width');

            if (!element) {
                console.log('没有找到匹配的元素');
                return 0;
            }

            // 获取元素的计算样式
            const computedStyle = getComputedStyle(element);

            // 获取 --page-width 的值
            const pageWidth = computedStyle.getPropertyValue('--page-width').trim();
            const pageWidthValue = parseFloat(pageWidth);
            const pageWidthUnit = pageWidth.match(/[a-zA-Z]+/)[0];

            let pageWidthInPx;
            if (pageWidthUnit === 'rem') {
                const rootFontSize = 10; // 根字体大小，可能需要根据实际情况调整
                pageWidthInPx = pageWidthValue * rootFontSize;
            } else {
                pageWidthInPx = pageWidthValue;
            }

            // 获取 --page-padding 的值
            const pagePadding = computedStyle.getPropertyValue('--page-padding').trim();
            const pagePaddingValue = parseFloat(pagePadding);
            const pagePaddingUnit = pagePadding.match(/[a-zA-Z]+/)[0];

            let pagePaddingInPx;
            if (pagePaddingUnit === 'rem') {
                const rootFontSize = 10; // 根字体大小，可能需要根据实际情况调整
                pagePaddingInPx = pagePaddingValue * rootFontSize;
            } else {
                pagePaddingInPx = pagePaddingValue;
            }

            // 计算滑动前的偏移量
            const slidesOffsetBefore = (window.innerWidth - pageWidthInPx - pagePaddingInPx) / 2;

            return slidesOffsetBefore;
        }

        initializeSwiper() {
            if (!this._swiperContainer) {
                console.error('Swiper container not found');
                return;
            }

            const nextButton = this._swiperContainer.querySelector('.swiper-button-next');
            const prevButton = this._swiperContainer.querySelector('.swiper-button-prev');
            const slidesOffsetBefore = this._calculateSlidesOffsetBefore();
            this._swiperInstance = new Swiper(this._swiperContainer, {
                slidesPerGroup: 1,
                slidesPerView: 3.4,
                spaceBetween: 25,
                loop: false,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.3,
                        spaceBetween: 15,
                        slidesOffsetBefore: 22,
                        slidesOffsetAfter: 22,
                        // autoHeight: true,
                    },
                    768: {
                        slidesPerView: 1.8,
                        slidesOffsetBefore: 22,
                        slidesOffsetAfter: 22,
                        // autoHeight: false,
                    },
                    800: {
                        slidesPerView: 2.2,
                        slidesOffsetBefore: 22,
                        slidesOffsetAfter: 22,
                    },
                    1024: {
                        spaceBetween: 20,
                        slidesPerView: 2.8,
                        slidesOffsetBefore: 22,
                        slidesOffsetAfter: 22,
                    },
                    1280: {
                        slidesPerView: 2.8,
                    },
                    1401: {
                        slidesOffsetBefore: slidesOffsetBefore,
                        slidesOffsetAfter: slidesOffsetBefore,
                        slidesPerView: 3.4,
                    },
                },
            });
        }

        // sameHeight() {
        //     const commentItems = this.querySelectorAll('.swiper-comment__item.no-image');
        //     if (window.innerWidth < 749) {
        //         commentItems.forEach(item => {
        //             const parentHeight = item.parentElement.offsetHeight;
        //             item.style.height = `${parentHeight}px`;
        //         });
        //     } else {
        //         commentItems.forEach(item => {
        //             item.style.height = '';
        //         });
        //     }
        // }
    }

    customElements.define('comment-item-swiper', CommentItemSwiper);
}


class CommentItemSwitch extends HTMLElement {
    constructor() {
        super();
        this._swiperContainer = null;
        this._typeSwiperContainer = null;
        this._swiperInstance = null;
        this._typeSwiperInstance = null;
        this._resizeHandler = this._onResize.bind(this);
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this._swiperContainer = this.querySelector('.comment-switch-swiper');
            this._typeSwiperContainer = this.querySelector('.comment-has_switch-swiper');
            this.initializeSwitchSwiper();
            this.initializeTypeSwiper();
            window.addEventListener('resize', this._resizeHandler);
        });
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this._resizeHandler);
    }

    _onResize() {
        if (this._swiperInstance) {
            this._swiperInstance.update();
        }
        if (this._typeSwiperInstance) {
            this._typeSwiperInstance.update();
        }
    }

    initializeSwitchSwiper() {
        if (!this._swiperContainer) {
            console.error('Swiper container not found');
            return;
        }


        this._swiperInstance = new Swiper(this._swiperContainer, {
            slidesPerGroup: 1,
            slidesPerView: 'auto',
            // centeredSlides: true,
            // centeredSlidesBounds: true,
            centerInsufficientSlides: true,
            spaceBetween: 0,
            loop: false,
            watchSlidesVisibility: true,
            breakpoints: {
                320: {
                    spaceBetween: 0,
                },
                768: {
                    spaceBetween: 0,
                },
            }
        });
    }
    initializeTypeSwiper() {
        if (!this._typeSwiperContainer) {
            console.error('TypeSwiper container not found');
            return;
        }


        this._typeSwiperInstance = new Swiper(this._typeSwiperContainer, {
            slidesPerGroup: 1,
            slidesPerView: 1,
            allowTouchMove: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            thumbs: {
                swiper: this._swiperInstance,
            }
        });
    }
}
customElements.define('comment-item-swiper-switch', CommentItemSwitch);